var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconUsers_svg__clip0_897_21)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 9.101a.564.564 0 00-.916.617c.028.068.07.13.123.182a5.063 5.063 0 011.502 3.6c0 .686-1.975 1.687-5.063 1.687-3.088 0-5.062-1-5.062-1.687a5.062 5.062 0 011.479-3.583.562.562 0 00-.397-.957.563.563 0 00-.396.164A6.143 6.143 0 002.813 13.5c0 1.828 3.189 2.812 6.187 2.812s6.188-.984 6.188-2.812A6.154 6.154 0 0013.354 9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.563a3.938 3.938 0 100-7.876 3.938 3.938 0 000 7.875zm0-6.75a2.812 2.812 0 110 5.624 2.812 2.812 0 010-5.624z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconUsers_svg__clip0_897_21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconUsers.75f9ac20.svg";
export { MemoForwardRef as ReactComponent };